module.exports = __webpack_public_path__ + "static/img/3.679dcb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/User/3.png
// module id = 4P4s
// module chunks = 0